import { render } from "./SelectOrganization.vue?vue&type=template&id=77b78976&scoped=true"
import script from "./SelectOrganization.vue?vue&type=script&lang=js"
export * from "./SelectOrganization.vue?vue&type=script&lang=js"

import "./SelectOrganization.vue?vue&type=style&index=0&id=77b78976&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b78976"]])

export default __exports__